import React, { useState, useEffect } from 'react';
import BlogCard from './BlogCard';
import { apiFetch } from '../../utils/api';

const RelatedBlogs = ({ currentBlogSlug, category }) => {
  const [related, setRelated] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRelatedBlogs = async () => {
      try {
        setLoading(true);
        const res = await apiFetch('/api/blogs');
        if (!res.ok) {
          throw new Error('Failed to fetch related blogs');
        }
        const data = await res.json();
        
        // Filter out current blog
        const others = data.filter((b) => b.slug !== currentBlogSlug);

        // Sort: blogs in same category first
        const sorted = others.sort((a, b) => {
          if (category && a.category === category && b.category !== category) return -1;
          if (category && b.category === category && a.category !== category) return 1;
          return 0;
        });

        setRelated(sorted.slice(0, 3));
      } catch {
        setRelated([]);
      } finally {
        setLoading(false);
      }
    };

    if (currentBlogSlug) {
      fetchRelatedBlogs();
    }
  }, [currentBlogSlug, category]);

  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {[1, 2, 3].map((n) => (
          <div key={n} className="h-80 animate-pulse rounded-2xl bg-slate-100 border border-slate-200" />
        ))}
      </div>
    );
  }

  if (related.length === 0) {
    return (
      <div className="rounded-2xl border border-dashed border-slate-200 bg-slate-50 p-8 text-center text-sm text-slate-500">
        No other related articles at the moment.
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {related.map((blog) => (
        <BlogCard key={blog._id} blog={blog} />
      ))}
    </div>
  );
};

export default RelatedBlogs;
